import { IBasicFieldLabelAndDetails } from './basic-label-value-pair.model';

export enum EAvailableConditionalValidations {
  required = 'required',
  min = 'min',
  max = 'max',
  minLength = 'minLength',
  maxLength = 'maxLength',
  patternValidation = 'patternValidation',
}

export enum EFormBuilderConditionComparator {
  OR = 'OR',
  AND = 'AND',
}

export enum EFormBuilderConditionalFieldComparator {
  IS_EQUAL_TO = 'Equal To',
  IS_NOT_EQUAL_TO = 'Not Equal To',
  IS_ABOVE = 'Above',
  IS_BELOW = 'Below',
  IS_VALID = 'of validity',
  IS_BOOLEAN_TRUE = 'of boolean value',
  IS_UNDEFINED = 'undefined',
  IS_DEFINED = 'defined',
}

export enum EConditionalPropertyType {
  'self' = 'self',
  'fieldValue' = 'fieldValue',
  'formStateValue' = 'formStateValue',
}

export interface IFormFieldsCompareValues {
  booleanValue?: boolean;
  validityValue?: boolean;
  isValue: any;
  valueAsNumber?: boolean;
  isUndefined?: boolean;
  isDefined?: boolean;
}

export interface IComparedFormStateValuePath {
  fieldKey?: string;
  formStateKey: string;
  valuePath: string;
}

export interface IConditionalValidationConfig {
  validation: unknown;
  conditions?: IFormFieldsConditionRule[];
  useCustomErrorMessage?: boolean;
  errorMessage?: string;
}

export interface IUtilValidationConfig {
  validationName: unknown;
  validationMessage: unknown;
  condition: IFormFieldsConditionRule;
}

export interface IFormFieldsConditionRule {
  condition: EFormBuilderConditionComparator;
  property1: IFieldConditionProperty;
  comparator: EFormBuilderConditionalFieldComparator;
  strictMode?: boolean;
  useOrEqualTo?: boolean;
  property2: IFieldConditionProperty;
}

export interface IFieldConditionProperty {
  propertyType: EConditionalPropertyType;
  propertyFormStateValuePath?: IComparedFormStateValuePath;
  propertyField?: {
    field: IBasicFieldLabelAndDetails<string>;
  };
  propertyValues?: IFormFieldsCompareValues;
}
